export default [
    "18 18",
    '<path d="M9 3.75V14.25M3.75 9H14.25" fill="none" class="stroke-over" stroke="var(--ci-primary-color, currentColor)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>']

